import React, { useRef } from 'react'
import styled from 'styled-components'
import { media } from 'utils/media'
import { ArrowLink } from 'lib/ArrowLink'
import { WideGrid } from 'lib/OldGrid'
import { MaxWidthContainer } from 'lib/Section'
import { SectionHeader as OriginalSectionHeader } from 'modules/homepage/SectionHeader'
import { CurrentDropsCarousel } from './components/CurrentDropsCarousel'

const Title = styled(OriginalSectionHeader)`
  grid-column: start / 11;
  ${media.tabletDown} {
    grid-column: start / end;
  }
`

const HeaderContainer = styled(MaxWidthContainer)`
  margin-bottom: 24px;
`

const NoMarginArrowLink = styled(ArrowLink)`
  grid-column: 11 / end;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  ${media.tabletDown} {
    display: none;
  }
`

export const HomepageThingdrop = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null)

  return (
    <section>
      <HeaderContainer>
        <WideGrid>
          <Title title="Thingdrop of the week" />
          <NoMarginArrowLink url="/thingdrop?from=homepage" label="View all" arrowPosition="right" textProps={{ size: 'ps', weight: 'medium' }} />
        </WideGrid>
      </HeaderContainer>
      <CurrentDropsCarousel ref={scrollRef} />
    </section>
  )
}
